module.exports = __webpack_public_path__ + "static/media/unnamed-6@2x.209917c7.png";